var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFavoritesOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.688 2.04769C10.8178 1.79254 11.1823 1.79254 11.312 2.04769L13.8416 7.02267C13.9649 7.2651 14.1967 7.43391 14.4653 7.47679L19.9683 8.3552C20.2501 8.40018 20.3625 8.7454 20.1612 8.9477L16.2208 12.9076C16.0297 13.0997 15.9416 13.3714 15.9836 13.6391L16.8517 19.163C16.8961 19.4454 16.6014 19.659 16.3468 19.529L11.3865 16.9964C11.1438 16.8724 10.8562 16.8724 10.6135 16.9964L5.65321 19.529C5.39857 19.659 5.10391 19.4454 5.1483 19.163L6.01637 13.6391C6.05844 13.3714 5.97034 13.0997 5.7792 12.9076L1.83882 8.9477C1.63752 8.7454 1.74993 8.40018 2.03174 8.3552L7.5347 7.47679C7.80328 7.43391 8.03513 7.26511 8.1584 7.02267L10.688 2.04769Z",
    stroke: "#5E5F66",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFavoritesOff);
export default __webpack_public_path__ + "static/media/ic_favorites_off.1d450769665b4d3de96ad64b55755ea8.svg";
export { ForwardRef as ReactComponent };